import { c as _c } from "react/compiler-runtime";
import { Toaster } from '@/components';
import SeoMetadata from '@/components/seo/SeoMetadata';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useRouter } from 'next/router';
import { useOnboardingTutorial } from '@/hooks/useOnboardingTutorial';
import { ReactNode, useEffect } from 'react';
import { DesktopLayout } from './DesktopLayout';
import { MobileLayout } from './MobileLayout';
import { TopBarNotificationTriggers } from './TopBarNotificationTriggers';
import { SetupWizard } from '../onboarding/SetupWizard';
type LayoutProps = {
  children: ReactNode;
};
const toastOptions = {
  unstyled: true,
  classNames: {
    success: 'flex items-center gap-2 bg-[#1FC16B] px-3 py-1.5 text-sm font-medium text-white rounded-full',
    error: 'flex items-center gap-2 bg-destructive px-3 py-1.5 text-sm font-medium text-white rounded-full'
  }
};
const Layout = t0 => {
  const $ = _c(21);
  const {
    children
  } = t0;
  const {
    isMobile
  } = useIsMobile();
  const router = useRouter();
  const {
    isSetupModeVisible,
    dismiss
  } = useOnboardingTutorial();
  let t1;
  if ($[0] !== isSetupModeVisible || $[1] !== router.pathname || $[2] !== router.query) {
    t1 = isSetupModeVisible || router.query.forceSetup === "true" || router.pathname.startsWith("/onboarding/");
    $[0] = isSetupModeVisible;
    $[1] = router.pathname;
    $[2] = router.query;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isSetupActive = t1;
  let t2;
  let t3;
  if ($[4] !== dismiss || $[5] !== isSetupActive || $[6] !== router.pathname) {
    t2 = () => {
      if (isSetupActive && router.pathname.startsWith("/settings/")) {
        dismiss();
      }
    };
    t3 = [isSetupActive, router.pathname, dismiss];
    $[4] = dismiss;
    $[5] = isSetupActive;
    $[6] = router.pathname;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== router.pathname) {
    t4 = router.pathname.startsWith("/onboarding/") || router.pathname.includes("/whatsapp/profile") || router.pathname.includes("/personal-whatsapp") || router.pathname.includes("/instagram/connect");
    $[9] = router.pathname;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const isConnectionPage = t4;
  const showWizardAsPage = isSetupActive && !isConnectionPage;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SeoMetadata />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== isMobile || $[14] !== isSetupActive || $[15] !== showWizardAsPage) {
    t6 = isMobile ? <MobileLayout hideNav={isSetupActive}>{showWizardAsPage ? <SetupWizard /> : children}</MobileLayout> : <DesktopLayout hideSidebar={isSetupActive}>{showWizardAsPage ? <SetupWizard /> : children}</DesktopLayout>;
    $[12] = children;
    $[13] = isMobile;
    $[14] = isSetupActive;
    $[15] = showWizardAsPage;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Toaster position="top-center" mobileOffset={{
      top: "calc(env(safe-area-inset-top, 0px) + 16px)"
    }} toastOptions={toastOptions} />;
    t8 = <TopBarNotificationTriggers />;
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6) {
    t9 = <>{t5}{t6}{t7}{t8}</>;
    $[19] = t6;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export { Layout };